import { generatePath } from "react-router";
import querystring from "query-string";

import createFormActions from "modules/form/actions";

import { WORKSPACES } from "utils/constants/routes";
import { getArrayFromQuery } from "utils/parsers";
import history from "services/history";

import {
  workspacesWorkloadsModules,
  workspaceSelectedWorkloadModal,
  workspaceSelectedWorkloadUsageFetcher,
  workspaceWorkloadUsageFetcher,
} from "../services/workloads";
import { WORKLOADS_WITH_METRICS } from "utils/constants";

export const WORKLOADS_FILTERS_MODULE = "workspaceWorkloadsFilters";

export const workloadsFilters = createFormActions({
  init: () => {
    const query = history.getQuery();
    const namespaces = getArrayFromQuery(query?.namespaces);
    const clusters = getArrayFromQuery(query?.clusters);

    return Promise.resolve({
      namespaces,
      clusters,
      workloadPeriod: "6 hours",
      workloadUsageType: "cpu",
      selectedWorkloadUsageType: "cpu",
    });
  },
});

export function onNamespaceFilterSelect(value) {
  return (dispatch, getState) => {
    const { workloadPeriod, clusters } =
      getState().forms?.[WORKLOADS_FILTERS_MODULE]?.data || {};

    dispatch(
      workloadsFilters.onChange({
        module: WORKLOADS_FILTERS_MODULE,
        name: "namespaces",
        value,
      })
    );
    const currentTab = getState().location.params.flag;
    if (workspacesWorkloadsModules[currentTab]) {
      dispatch(
        workspacesWorkloadsModules[currentTab].listActions.changeQuery({
          name: "namespaces",
          value,
          module: workspacesWorkloadsModules[currentTab].module,
        })
      );
    }

    if (WORKLOADS_WITH_METRICS.includes(currentTab)) {
      dispatch(
        workspaceWorkloadUsageFetcher.fetch({
          timeRange: workloadPeriod,
          namespaces: value,
          clusters,
        })
      );
    }
  };
}

export function onClusterFilterSelect(value) {
  return (dispatch, getState) => {
    const { workloadPeriod, namespaces } =
      getState().forms?.[WORKLOADS_FILTERS_MODULE]?.data || {};

    dispatch(
      workloadsFilters.onChange({
        module: WORKLOADS_FILTERS_MODULE,
        name: "clusters",
        value,
      })
    );
    const currentTab = getState().location.params.flag;
    if (workspacesWorkloadsModules[currentTab]) {
      dispatch(
        workspacesWorkloadsModules[currentTab].listActions.changeQuery({
          name: "clusters",
          value,
          module: workspacesWorkloadsModules[currentTab].module,
        })
      );
    }

    if (WORKLOADS_WITH_METRICS.includes(currentTab)) {
      dispatch(
        workspaceWorkloadUsageFetcher.fetch({
          timeRange: workloadPeriod,
          namespaces,
          clusters: value,
        })
      );
    }
  };
}

export function onUsageTypeChange(value) {
  return (dispatch) => {
    dispatch(
      workloadsFilters.onChange({
        module: WORKLOADS_FILTERS_MODULE,
        name: "workloadUsageType",
        value,
      })
    );
  };
}

export function onPodsChartPeriodChange(value) {
  return (dispatch, getState) => {
    const { namespaces, clusters } =
      getState().forms?.[WORKLOADS_FILTERS_MODULE]?.data || {};

    dispatch(
      workloadsFilters.onChange({
        module: WORKLOADS_FILTERS_MODULE,
        name: "workloadPeriod",
        value,
      })
    );

    const currentTab = getState().location.params.flag;

    if (WORKLOADS_WITH_METRICS.includes(currentTab)) {
      dispatch(
        workspaceWorkloadUsageFetcher.fetch({
          timeRange: value,
          namespaces,
          clusters,
        })
      );
    }
  };
}

export function openWorkspaceWorkloadDetailsModal(guid) {
  return (dispatch, getState) => {
    const { workloadPeriod, clusters, namespaces } =
      getState().forms?.[WORKLOADS_FILTERS_MODULE]?.data || {};

    workspaceSelectedWorkloadModal.open({ guid });
    dispatch(onWorkloadUsageTypeChange("cpu"));
    dispatch(
      workspaceSelectedWorkloadUsageFetcher.fetch({
        timeRange: workloadPeriod,
        clusters,
        namespaces,
      })
    );
  };
}

export function onWorkloadUsageTypeChange(value) {
  return (dispatch) => {
    dispatch(
      workloadsFilters.onChange({
        module: WORKLOADS_FILTERS_MODULE,
        name: "selectedWorkloadUsageType",
        value,
      })
    );
  };
}

export function navigateToPods(namespace) {
  return (dispatch, getState) => {
    const { id } = getState().location.params || {};
    const podsPath = generatePath(WORKSPACES.WORKSPACE_DETAILS_OVERVIEW, {
      id,
      flag: "pods",
      tab: "overview",
    });

    const query = querystring.stringify({
      namespaces: [namespace.metadata.entity.name],
    });

    history.push(`${podsPath}?${query}`);
  };
}
